import { getCellValue, formatValue } from "./formatters";

/**
 * Export an array of rows to CSV using the column definitions.
 * Uses column.label as header, column.accessor/key for the value,
 * and column.format for any formatting (dates, numbers, currency).
 *
 * Skips columns with export === false or columns without a key (e.g. actions).
 */
export const exportToCsv = ({ rows, columns, filename = "export" }) => {
  const exportable = columns.filter(
    (c) => c.export !== false && c.key && !c.key.startsWith("_")
  );

  const escape = (val) => {
    if (val == null) return "";
    const s = String(val);
    if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
  };

  const header = exportable.map((c) => escape(c.label ?? c.key)).join(",");
  const body = rows
    .map((row) =>
      exportable
        .map((c) => {
          const raw = getCellValue(row, c);
          const out = c.exportValue ? c.exportValue(raw, row) : formatValue(raw, c);
          return escape(out);
        })
        .join(",")
    )
    .join("\n");

  const csv = `${header}\n${body}`;
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}_${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
